type ProductOptionError = {
  message: string;
  originalError?: unknown;
};

export const reportProductOptionError = (error: ProductOptionError) => {
  // TODO: 센트리 수집
  console.error(`Product Option Error:`, error.message, error.originalError);
};
